export default {
  translations: {
    'Try it out': 'Pruébalo',
    'Preview not available': 'Vista previa no disponible',
    'New Board': 'Nuevo tablero',
    'Import from .zip': 'Importar .zip',
    'Importing...': 'Importando...',
    'Failed to import board.': 'Error al importar el tablero.',
    'Create board on the tablet?': '¿Crear tablero en la tableta?',
    'Import board to the tablet?': '¿Importar tablero a la tableta?',
    "This board will be created in this user's tablet backup, not in your Portal boards. It will be sent to the tablet on the next sync.":
      'Este tablero se creará en la copia de seguridad de la tableta de este usuario, no en tus tableros del Portal. Se enviará a la tableta en la próxima sincronización.',
    'Board title': 'Título del tablero',
    'Enter a title for the board': 'Escribe un título para el tablero',
    'Card language': 'Idioma de la tarjeta',
    'Creating...': 'Creando...',
    'Failed to create board.': 'No se pudo crear el tablero.',
    'Choose an image from the bank, generate one with AI or upload your own.':
      'Elige una imagen del banco, genera una con IA o sube la tuya.',
    'Used for the symbol bank and speech (text-to-speech) of this board.':
      'Se usa para el banco de símbolos y la voz (texto a voz) de este tablero.',
    'How do you want to start?': '¿Cómo quieres empezar?',
    'Blank board': 'Tablero en blanco',
    'Start with tutorial': 'Empezar con tutorial',
    'Create a board from scratch': 'Crea un tablero desde cero',
    'Learn the studio with a ready-made board':
      'Aprende el studio con un tablero listo',
    'Is this your first time creating boards?':
      '¿Es la primera vez que creas tableros?',
    "Don't show this again": 'No mostrar de nuevo',
    'Choose a title for your board': 'Elige un título para tu tablero',
    'Preview board': 'Vista previa del tablero',
    'Displayed text': 'Texto mostrado',
    'Back and edit': 'Volver y editar',
    SMALL: 'Pequeño',
    MEDIUM: 'Mediano',
    LARGE: 'Grande',
    login: {
      welcome: '¡Bienvenido a Livox!',
      error:
        'No es posible iniciar sesión con los datos proporcionados. Correo electrónico y/o contraseña incorrectos.',
      inactive_customer:
        'Su cuenta ha sido desactivada. Póngase en contacto con el soporte para obtener ayuda.',
    },
    payment: {
      purchaseFor: 'Compra para',
      supportEmail: 'Correo de contacto',
    },
    paymentRegister: {
      title: 'Regístrate para comprar Livox',
      orLoginWithAccount: '¿Ya tienes una cuenta?',
      loginToComplete: 'Inicia sesión para completar tu compra',
      orRegisterNew: 'O regístrate para crear una cuenta nueva',
      email: 'Correo electrónico',
      fullName: 'Nombre completo',
      emailRequired: 'El correo electrónico es obligatorio',
      fullNameRequired: 'El nombre completo es obligatorio',
      enterFullName: 'Ingresa tu nombre completo',
      codeInfo:
        'Recibirás un código de 6 dígitos por correo. El código es válido por 15 minutos.',
      sending: 'Enviando...',
      sendCode: 'Enviar código de activación',
      codeSentTo: 'Código enviado a',
      activationCode: 'Código de activación',
      resendCode: 'Reenviar código',
      continue: 'Continuar',
      validating: 'Validando...',
      codeValid: 'Código válido.',
      changeEmail: 'Cambiar correo',
      password: 'Contraseña',
      confirmPassword: 'Confirmar contraseña',
      enterPassword: 'Ingresa tu contraseña',
      confirmYourPassword: 'Confirma tu contraseña',
      passwordRequired: 'La contraseña es obligatoria',
      confirmPasswordRequired: 'Por favor confirma tu contraseña',
      activating: 'Activando...',
      activateAccount: 'Activar cuenta',
      back: 'Volver',
      accountExists: 'La cuenta ya existe. Inicia sesión para continuar.',
      codeSentSuccess:
        'Se ha enviado un código de activación de 6 dígitos a tu correo. Válido por 15 minutos.',
      newCodeSent: 'Se ha enviado un nuevo código a tu correo',
      somethingWrong: 'Algo salió mal',
      resendFailed: 'Error al reenviar el código',
      passwordsDontMatch: 'Las contraseñas no coinciden',
      activationFailed: 'Error de activación',
      accountActivated: '¡Cuenta activada con éxito!',
      codeExpired:
        'Código de activación expirado o inválido. Solicita uno nuevo.',
      invalidCode: 'Código de activación inválido.',
      accountAlreadyActive: 'Cuenta ya activa. Inicia sesión.',
      rateLimit: 'Espera un momento antes de solicitar un nuevo código.',
      passwordRequirements:
        'La contraseña debe contener al menos una mayúscula, una minúscula, un carácter especial, un número y tener mínimo 8 caracteres',
      holderAlreadyRegistered:
        'Ya existe un titular registrado con este correo. Inicie sesión en el portal.',
      holderAlreadyRegisteredTitle: 'Titular ya registrado',
      holderAlreadyRegisteredMessage:
        'Ya existe un titular registrado con este correo. Inicie sesión en el portal para acceder a su cuenta.',
      holderAlreadyRegisteredMessageWithEmail:
        'Ya existe un titular registrado con este correo. El correo {{email}} ya ha sido creado como titular. Inicie sesión en el portal para acceder a su cuenta.',
      tokenInvalidOrExpired: 'Su token es inválido o ha expirado',
      goToLogin: 'Ir a iniciar sesión',
    },
    pm: {
      cards: 'Tarjetas',
      manageYourPayment:
        'Gestiona tu información de pago. Para ver los detalles de tu suscripción mensual, ve a Suscripciones.',
      defaultPayment: 'Pago predeterminado',
      setAsDefault: 'Definir como predeterminado',
      addCard: 'Agregar tarjeta',
      addBoleto: 'Agregar boleto',
      creditCard: 'Tarjeta de Crédito',
      boleto: 'Boleto',
      add: 'Agregar',
      boletos: 'Boletos',
    },
    Role: 'Perfil',
    Often: 'Frecuentemente',
    Sometimes: 'A veces',
    Never: 'Nunca',
    Date: 'Fecha',
    CGQ: 'CGT',
    VIQ: 'VIS',
    AUQ: 'AUD',
    OLQ: 'CLO',
    BHQ: 'CMP',
    Overall: 'General',
    Actions: 'Acciones',
    'Holder Info': 'Información del Titular',
    Loading: 'Cargando',
    Profile: 'Perfil',
    Comments: 'Comentarios',
    'View Branch': 'Ver Sucursal',
    'Add License to Branch': 'Agregar licencia a la sucursal',
    'Create Board': 'Crear tablero',
    'Review Publication': 'Revisar publicación',
    Creator: 'Creador',
    'Board History': 'Historial de tableros',
    'Change Customers to Support Area': 'Cambiar clientes al área de soporte',
    'Change Users to Support Area': 'Cambiar usuarios al área de soporte',
    'Change Licenses to Branch': 'Cambiar licencias a sucursal',
    'Tablet code': 'Código de la tablet',
    Back: 'Volver',
    'Livox Store': 'Tienda Livox',
    Communication: 'Comunicación',
    Leisure: 'Ocio',
    Feelings: 'Sentimientos',
    Hospital: 'Hospital',
    Social: 'Social',
    'Daily Life': 'Vida diaria',
    Foods: 'Alimentación',
    School: 'Escuela',
    Education: 'Educación',
    Literacy: 'Alfabetización',
    Grammar: 'Gramática',
    Geography: 'Geografía',
    Science: 'Ciencias',
    History: 'Historia',
    Math: 'Matemáticas',
    Biology: 'Biología',
    Fun: 'Diversión',
    Stories: 'Historias',
    Games: 'Juegos',
    Game: 'Juego',
    Memory: 'Memoria',
    'Questions and Answers': 'Preguntas y Respuestas',
    'Popular Items': 'Artículos populares',
    'See more': 'Ver más',
    Code: 'Código',
    'Last Modified': 'Última modificación',
    'Upload from .zip': 'Subir desde .zip',
    'My Boards': 'Mis tableros',
    'My Portal Boards': 'Mis Pizarras del Portal',
    'Welcome {{name}}, you have {{count}} licenses':
      'Bienvenido/a {{name}}, tienes {{count}} licencias',
    'Publish one of your boards to share it with the Livox community.':
      'Publica una de tus pizarras para compartirla con la comunidad Livox.',
    'Welcome {{name}}, you have {{count}} users':
      'Bienvenido/a {{name}}, tienes {{count}} usuarios',
    'A-Z': 'A-Z',
    Size: 'Tamaño',
    Studio: 'Studio',
    Favorites: 'Favoritos',
    Keyboard: 'Teclado',
    Import: 'Importar',
    Assign: 'Asignar',
    'Cover Art': 'Arte de portada',
    Title: 'Título',
    Description: 'Descripción',
    Categories: 'Categorías',
    Submitter: 'Remitente',
    'Published at': 'Publicado en',
    View: 'Visualizar',
    'Pending Approval': 'Pendiente de aprobación',
    'Holders Search': 'Búsqueda de titulares',
    'Filter Status': 'Filtrar estado',
    'Audit Licenses': 'Auditar licencias',
    'No Device': 'Sin dispositivo',
    'Livox Version': 'Versión de Livox',
    'Android Version': 'Versión de Android',
    'Last Validation At': 'Última validación en',
    Manage: 'Gestionar',
    Store: 'Tienda',
    Books: 'Libros',
    'Sign up': 'Registrarse',
    Talk: 'Hablar',
    Learn: 'Aprender',
    Admin: 'Admin',
    'Store Admin': 'Admin de la Tienda',
    'Discover new boards, games and stories':
      'Descubre nuevos tableros, juegos e historias',
    'Search in store': 'Buscar en la tienda',
    'Search boards, games, stories...': 'Buscar tableros, juegos, historias...',
    'Recommended content': 'Contenido recomendado',
    'Featured boards': 'Tableros destacados',
    'New content': 'Contenido nuevo',
    'Featured creators': 'Creadores destacados',
    'Sort by': 'Ordenar por',
    Downloads: 'Descargas',
    'Livox Community': 'Comunidad Livox',
    'Total downloads': 'Descargas totales',
    'Community content': 'Contenido de la comunidad',
    Follow: 'Seguir',
    Following: 'Siguiendo',
    'View content': 'Ver contenido',
    Community: 'Comunidad',
    Logout: 'Cerrar sesión',
    'No description': 'Sin descripción',
    'No Title': 'Sin título',
    New: 'Nuevo',
    'My content': 'Mis contenidos',
    'Unable to load your content': 'No se pudieron cargar tus contenidos',
    'Import board': 'Importar tablero',
    'Created by': 'Creado por',
    'Board tags': 'Etiquetas del tablero',
    'No tags': 'Sin etiquetas',
    'Report content': 'Reportar contenido',
    'Report reason': 'Motivo del reporte',
    Report: 'Reportar',
    'Report sent': 'Reporte enviado',
    'Failed to send report': 'No se pudo enviar el reporte',
    'Offensive content': 'Contenido ofensivo',
    'Inappropriate language': 'Lenguaje inapropiado',
    'Sexual or inappropriate content': 'Contenido sexual o inapropiado',
    Violence: 'Violencia',
    'Hate speech': 'Discurso de odio',
    'Spam or advertising': 'Spam o publicidad',
    'Copyright infringement': 'Infracción de derechos de autor',
    'Duplicate content': 'Contenido duplicado',
    'Off-topic content': 'Contenido fuera de tema',
    'Exposed personal data': 'Datos personales expuestos',
    'Content deleted': 'Contenido eliminado',
    'Failed to delete content': 'No se pudo eliminar el contenido',
    'Sending...': 'Enviando...',
    'New Releases': 'Novedades',
    'Top Rated': 'Mejor Valorados',
    'See all': 'Ver todo',
    'Browse by category': 'Explorar por categoría',
    'No content found': 'No se encontró contenido',
    'Try adjusting your filters': 'Intenta ajustar tus filtros',
    'Go to slide': 'Ir a la diapositiva',
    'Back to Store': 'Volver a la Tienda',
    'Loading board...': 'Cargando publicación...',
    'No description provided': 'Sin descripción',
    stars: 'estrellas',
    votes: 'votos',
    Rate: 'Valorar',
    'Be the first to rate': 'Sé el primero en valorar',
    'In progress': 'En progreso',
    'Tablet preview': 'Vista previa en tablet',
    'Tablet preview coming soon': 'Vista previa en tablet próximamente',
    Republish: 'Republicar',
    Filters: 'Filtros',
    Clear: 'Limpiar',
    Speak: 'Hablar',
    Previous: 'Anterior',
    'Previous page': 'Página anterior',
    'Next page': 'Página siguiente',
    'Remove last': 'Borrar último',
    Fullscreen: 'Pantalla completa',
    'Exit fullscreen': 'Salir de pantalla completa',
    'Go to Portal': 'Ir al Portal',
    'Sign in': 'Iniciar sesión',
    'Sign out': 'Cerrar sesión',
    'Open menu': 'Abrir menú',
    'Close menu': 'Cerrar menú',
    Menu: 'Menú',
    'Publication not available': 'Esta publicación no está disponible',
    'All languages': 'Todos los idiomas',
    'Switch to dark mode': 'Cambiar a modo oscuro',
    'Switch to light mode': 'Cambiar a modo claro',
    'Toggle theme': 'Alternar tema',
    'Sign in to download': 'Inicia sesión para descargar',
    'Sign in to rate': 'Inicia sesión para valorar',
    'Author not found': 'Autor no encontrado',
    'Unnamed author': 'Autor sin nombre',
    publication: 'publicación',
    publications: 'publicaciones',
    'Boards by this author': 'Tableros de este autor',
    'Link copied to clipboard': 'Enlace copiado al portapapeles',
    'Failed to download content': 'Error al descargar el contenido',
    'Download started': 'Descarga iniciada',
    'Thanks for your vote!': '¡Gracias por tu voto!',
    'Failed to send vote': 'Error al enviar el voto',
    'Content promoted': 'Contenido promovido',
    'View profile': 'Ver perfil',
    'Page Size': 'Tamaño de página',
    'Licenses Search': 'Buscar Licencias',
    Licenses: 'Licencias',
    'Stripe Information': 'Información de Stripe',
    'No information': 'Sin información',
    Canceled: 'Cancelado',
    past_due: 'Pago atrasado',
    active: 'Activado',
    'Support Areas': 'Áreas de Soporte',
    Customers: 'Clientes',
    'Livox Users': 'Usuarios Livox',
    'Distributor Totals': 'Estadísticas de distribuidor',
    'Portal Administration': 'Administración del Portal',
    'My Devices': 'Mis Dispositivos',
    'My Livox Users': 'Mis Usuarios Livox',
    'My Licenses': 'Mis Licencias',
    'My Authorized Users': 'Mis Usuarios Autorizados',
    'New Customer': 'Nuevo Cliente',
    'Notify Customer': 'Notificar Cliente',
    'New Branch': 'Nueva Sucursal',
    'New Portal User': 'Nuevo Usuario del Portal',
    'Install Key': 'Clave de instalación',
    'License Key': 'Clave de licencia',
    'New License': 'Nueva Licencia',
    'New Registration Link': 'Crear enlace de activación',
    'All Livox users': 'Todos los Usuarios Livox',
    Home: 'Inicio',
    Customer: 'Cliente',
    'My Branches': 'Mis Sucursales',
    Branches: 'Sucursales',
    'Last Name': 'Apellido',
    Gender: 'Género',
    Age: 'Edad',
    Evaluations: 'Evaluaciones',
    'Last Evalution': 'Última Evaluación',
    License: 'Licencia',
    Key: 'Clave',
    Status: 'Estado',
    City: 'Ciudad',
    State: 'Estado',
    Country: 'País',
    Available: 'Disponible',
    Active: 'Activado',
    Inactive: 'Inactivo',
    Phone: 'Teléfono',
    'First Name': 'Nombre',
    'Device Name': 'Nombre del Dispositivo',
    Version: 'Versión',
    'Remove Device': 'Eliminar Dispositivo',
    User: 'Usuario',
    Contact: 'Contacto',
    Diagnosis: 'Diagnóstico',
    Device: 'Dispositivo',
    'Delete User': 'Eliminar Usuario',
    'My Users': 'Usuario de Livox',
    Expire: 'Fecha de expiración',
    Support: 'Soporte',
    Dates: 'Fechas',
    'Expiration Date': 'Fecha de Expiración',
    'Support Date': 'Fecha de Soporte',
    'Click to edit expiration date':
      'Haga clic para editar la fecha de expiración',
    'Click to edit support date': 'Haga clic para editar la fecha de soporte',
    'Expiration date updated successfully':
      'Fecha de expiración actualizada con éxito',
    'Support date updated successfully':
      'Fecha de soporte actualizada con éxito',
    'Failed to update expire date':
      'Error al actualizar la fecha de expiración',
    'Failed to update support date': 'Error al actualizar la fecha de soporte',
    'MAC Address': 'Dirección MAC',
    'Device Version': 'Versión del dispositivo',
    Name: 'Nombre',
    'Num. Licenses': 'Num. Licencias',
    Activated: 'Activado',
    Inactivated: 'Inactivado',
    Email: 'Correo electrónico',
    'My Auth Users': 'Mis Usuarios Autorizados',
    Holder: 'Titular',
    'Customer Licenses': 'Licencias del Cliente',
    Type: 'Tipo',
    Distribution: 'Distribuidor',
    Language: 'Idioma',
    Reseller: 'Revendedor',
    Text: 'Texto',
    'Number of Devices': 'Número de dispositivos',
    'Lifetime License': 'Licencia vitalicia',
    Address: 'Dirección',
    Zipcode: 'Código postal',
    Neighborhood: 'Barrio',
    'Contact Email': 'Correo de contacto',
    'Confirm Contact Email': 'Confirmar el correo de contacto',
    'First name': 'Nombre',
    'Last name': 'Apellido',
    Group: 'Grupo',
    Password: 'Contraseña',
    Male: 'Masculino',
    Female: 'Femenino',
    'My Portal Users': 'Mis Usuarios del Portal',
    'Edit Profile': 'Editar Perfil',
    'Change Password': 'Cambiar contraseña',
    Register: 'Registrar',
    'I forgot my password': 'Olvidé mi contraseña',
    Account: 'Cuenta',
    'No results': 'Sin resultados',
    'Customers Search': 'Búsqueda de clientes',
    Search: 'Buscar',
    'Search by name or email': 'Buscar por nombre o correo',
    'Tree view': 'Vista de árbol',
    'Table view': 'Vista de tabla',
    Download: 'Descargar',
    'Registration Link': 'Enlace de Registro',
    Page: 'Página',
    of: 'de',
    results: 'resultados',
    'View Branches': 'Ver Sucursales',
    'View Users': 'Ver Usuarios',
    Cancel: 'Cancelar',
    Create: 'Crear',
    'Branch Name': 'Nombre de la sucursal',
    'Confirm Password': 'Confirmar contraseña',
    'Customer Branches': 'Sucursales del Cliente',
    'My Evaluations': 'Mis evaluaciones',
    'Livox User': 'Usuario de Livox',
    'Add Branch': 'Agregar Sucursal',
    'Distributor Customers': 'Clientes del distribuidor',
    'New Support Area': 'Nueva área de soporte',
    'Assign Users': 'Asignar usuarios',
    'Assign Customers': 'Asignar clientes',
    Dashboard: 'Panel de control',
    'Unique users by day': 'Usuarios únicos por día',
    'Users by language': 'Usuarios por idioma',
    'Users by country': 'Usuarios por país',
    Devices: 'Dispositivos',
    'Manage my devices': 'Gestionar mis dispositivos',
    News: 'Novedades',
    'Read more': 'Leer más',
    'Total Licenses': 'Total de Licencias',
    'Paid Licenses': 'Licencias Compradas',
    'Free Licenses': 'Licencias Donadas',
    'Distributor Stats': 'Estadísticas del Distribuidor',
    Users: 'Usuarios',
    Remove: 'Eliminar',
    Evaluate: 'Evaluar',
    'Cognitive Evaluation': 'Evaluación Cognitiva',
    'Recognizes images': 'Reconoce imágenes',
    'Notion of cause and effect': 'Noción de causa y efecto',
    'Has notion of body awareness': 'Tiene noción de conciencia corporal',
    'Has symbolic representation': 'Tiene representación simbólica',
    'Makes choices': 'Hace elecciones',
    Literate: 'Alfabetizado',
    'Auditory Agnosia': 'Agnosia Auditiva',
    'Cow mooing': 'Vaca mugiendo',
    'Chicken clucking': 'Gallina cacareando',
    'Dog barking': 'Perro ladrando',
    Doorbell: 'Timbre de puerta',
    Sirens: 'Sirenas',
    'Visual Agnosia': 'Agnosia Visual',
    Dog: 'Perro',
    Cat: 'Gato',
    Bird: 'Pájaro',
    House: 'Casa',
    Banana: 'Banana',
    Grapes: 'Uva',
    Pineapple: 'Piña',
    Watermelon: 'Sandía',
    Telephone: 'Teléfono',
    Car: 'Coche',
    Shoe: 'Zapato',
    Ball: 'Pelota',
    'Visual Oral Language': 'Lenguaje Oral Visual',
    'Where is the ball?': '¿Dónde está la pelota?',
    'Where is the doll?': '¿Dónde está la muñeca?',
    'Are you at home?': '¿Estás en casa?',
    'What is the name of your mother?': '¿Cuál es el nombre de tu madre?',
    'What is your name?': '¿Cuál es tu nombre?',
    'Does he/she know his/her birthday?': '¿Conoce la fecha de su cumpleaños?',
    'Does he/she know his/her name?': '¿Conoce su nombre?',
    'Does he/she orient to date/time?': '¿Se orienta con la fecha/hora?',
    'Can he/she follow one step directions?':
      '¿Puede seguir instrucciones de un paso?',
    'Can he/she follow two step directions?':
      '¿Puede seguir instrucciones de dos pasos?',
    'Behavior Evaluation': 'Evaluación de Comportamiento',
    'Does he/she bite?': '¿Muerde?',
    'Does he/she hit his/her head on the wall?':
      '¿Se golpea la cabeza contra la pared?',
    'Does he/she understand feelings?': '¿Entiende los sentimientos?',
    'Does he/she sleep well?': '¿Duerme bien?',
    General: 'General',
    'Does he/she cry?': '¿Llora?',
    'Does he/she have temper tantrums?': '¿Tiene rabietas?',
    'Is he/she aggressive?': '¿Es agresivo?',
    'Does he/she eat well?': '¿Come bien?',
    'Does he/she run from one place to another?': '¿Corre de un lugar a otro?',
    'Does he/she focus in an activity?': '¿Se concentra en una actividad?',
    'Does he/she play with other children?': '¿Juega con otros niños?',
    'Does he/she have a hard time to sleep?': '¿Tiene problemas para dormir?',
    'Does he/she like to be alone?': '¿Le gusta estar solo?',
    'Does he/she demonstrate joint attention?': '¿Demuestra atención conjunta?',
    'Does he/she scream?': '¿Grita?',
    'Is he/she hypersensitive to sensory stimuli?':
      '¿Es hipersensible a los estímulos sensoriales?',
    'Is he/she unaware to sensory stimuli?':
      '¿Es insensible a los estímulos sensoriales?',
    Holders: 'Titulares',
    Purcharse: 'Comprar',
    Edit: 'Editar',
    Delete: 'Eliminar',
    'E-mail': 'Correo electrónico',
    'Full Name': 'Nombre completo',
    'Phone Number': 'Número de teléfono',
    Save: 'Guardar',
    Undo: 'Deshacer',
    Publish: 'Publicar',
    'New Item': 'Nuevo item',
    Attributes: 'Atributos',
    'Display Text': 'Texto a mostrar',
    'Spoken Phrase': 'Frase hablada',
    'Expand image on click': 'Expandir imagen al hacer clic',
    Colors: 'Colores',
    Pictures: 'Fotos',
    'Search a symbol': 'Buscar un símbolo',
    'Field Changed': 'Campo cambiado',
    'Old Value': 'Valor antiguo',
    'New Value': 'Nuevo valor',
    'License History': 'Historial de Licencia',
    Branch: 'Sucursal',
    'Evaluation Date': 'Fecha de Evaluación',
    'Branch Licenses': 'Licencias de la Sucursal',
    'Add Licenses to Branch': 'Agregar licencias a la Sucursal',
    Confirm: 'Confirmar',
    Close: 'Cerrar',
    'Livox version distribution': 'Distribución por versión de Livox',
    'Expires in': 'Expira en',
    'Support ends': 'El soporte termina en',
    available: 'disponible',
    'Android OS distribution': 'Distribución por Versión de Android',
    likes: 'me gusta',
    downloads: 'descargas',
    'Reviewed at': 'Revisado en',
    Comment: 'Comentar',
    Pending: 'Pendiente',
    Approved: 'Aprobado',
    Archived: 'Archivado',
    Accept: 'Aceptar',
    Reject: 'Rechazar',
    Reason: 'Motivo',
    Rejected: 'Rechazado',
    'Create License Registration Link': 'Crear enlace de registro de licencia',
    'Create separate install keys': 'Crear claves de instalación separadas',
    'Log Out': 'Cerrar sesión',
    'Evaluate Livox User': 'Evaluar usuario de Livox',
    Billing: 'Pago',
    'Acquire Livox': 'Adquirir el Livox',
    'You are about to purchase the best alternative comunication app in the world!':
      '¡Estás a punto de adquirir la mejor aplicación de comunicación alternativa del mundo!',
    '1. Select a Plan': '1. Selecciona un plan',
    BASIC: 'BÁSICO',
    'Up to 3 users': 'Hasta 3 usuarios',
    'Smart Scan': 'Escaneo Inteligente',
    'IntelliTouch - Touch Correction': 'IntelliTouch - Corrección de Toque',
    'Virtual keyboard': 'Teclado Virtual',
    'Stock Images (20,000 images)': 'Banco de imágenes (+20,000 imágenes)',
    'Creation of pedagogical content': 'Creación de contenido pedagógico',
    'Voice, text and image customization':
      'Personalización de voz, texto e imagen',
    'Content transfer between tablets':
      'Transferencia de contenido entre tablets',
    '/ month': 'por mes',
    'on a yearly plan': 'en el plan anual',
    PLUS: 'PLUS',
    'Recommended for families': 'Recomendado para familias',
    'New Features Update': 'Actualización de nuevas funciones',
    'Trigger Control': 'Control con Activadores',
    'Livox control with the blink of an eye':
      'Control con el parpadeo de los ojos',
    'Artificially Intelligent Item Recommendations Based on Time and Location':
      'Inteligencia Artificial para recomendar tarjetas basadas en la hora y ubicación',
    PRO: 'PRO',
    'Recommended for professionals!': '¡Recomendado para profesionales!',
    'UNLIMITED Users': 'Usuarios ILIMITADOS',
    'Complete assessment and content tool to track users progress with Livox (patients or students)':
      'Evaluación completa y herramienta de contenido para monitorear el progreso de los usuarios con el Livox (pacientes o estudiantes)',
    '2. Select a payment plan': '2. Selecciona el plan de pago',
    monthly: 'mensual',
    quarterly: 'trimestral',
    '% off': '% de descuento',
    yearly: 'anual',
    '3. Confirm the value': '3. Confirma el valor',
    'per month': 'por mes',
    'Proceed with the checkout': 'Continuar',
    'Select a Plan': 'Selecciona el plan',
    Continue: 'Continuar',
    'Get Livox': 'Comprar el Livox',
    'Select a Plan - Livox Portal': 'Elija un plan - Livox',
    '1. Confirm your Plan': '1. Confirma tu Plan',
    '3. Confirm the plan': '3. Confirma el plan',
    Checkout: 'Confirmar',
    'Secure checkout': 'Pago Seguro',
    'per year': 'por año',
    Change: 'Cambiar',
    'per quarter': 'por trimestre',
    'Cardholder Name': 'Nombre del Titular',
    'Street address': 'Dirección',
    'Apartment / Suite / Unit / Building':
      'Apartamento / Suite / Unidad / Edificio',
    'Billing Address': 'Dirección de Pago',
    'Payment Info': 'Información de Pago',
    'Credit or debit card': 'Tarjeta de crédito o débito',
    'Credit card info secured by': 'Información de la tarjeta protegida por',
    'Please wait for your profile to load, or refresh the page.':
      'Espere a que se cargue su perfil o actualice la página.',
    Success: 'Éxito',
    'Upload from .zip file here': 'Subir archivo .zip aquí',
    'Published Title': 'Título de la Publicación',
    'Publish Content': 'Publicar Contenido',
    'Cover Image': 'Imagen de portada',
    'Upload Image': 'Subir Imagen',
    Buy: 'Comprar',
    Boards: 'Tableros',
    'Thanks for purcharsing Livox': 'Gracias por adquirir Livox',
    'We are processing your payment, a receipt will be sent to':
      'Estamos procesando tu pago, se enviará un recibo a',
    'with instructions on how activate Livox.':
      'con instrucciones de cómo activar Livox.',
    'If you have any question / issues': 'Si tienes alguna pregunta/problema',
    'contact our support.': 'contacta con nuestro soporte.',
    Deleted: 'Eliminado',
    'You have successfully submitted this board for reviewing, please wait up to 48 hours to be approved.':
      'Has enviado este tablero con éxito. Por favor, espera hasta 48 horas para ser aprobado.',
    'You have successfully registered, Please return to the tablet to proceed.':
      'Te has registrado con éxito, por favor regresa a la tablet para continuar.',
    'Validation notEmpty on coverImage failed':
      'Por favor, añade una imagen a tu publicación',
    'You are not logged in. Create your account to see more of this content':
      'No has iniciado sesión. Crea tu cuenta para ver más de este contenido.',
    'Buy Livox': 'Comprar Livox',
    'Select your plan and payment method to get started.':
      'Selecciona tu plan y método de pago para comenzar.',
    'payment.pageDescription':
      'Selecciona tu plan y método de pago para completar la compra.',
    'payment.propaganda':
      '¡Estás a punto de adquirir la mejor aplicación de comunicación alternativa del mundo!',
    'payment.activeSubscriptionsCount': '{{count}} suscripción(es) activa(s)',
    'payment.youHaveLicenses': 'Tienes licencias activas.',
    'payment.viewLicensesHere': 'Ver tus licencias aquí',
    'payment.youHaveActiveSubscriptions': 'Tienes suscripciones activas.',
    'payment.viewMyAssessments': 'Ver en Mis evaluaciones',
    'payment.viewMySubscriptions': 'Ver en Mis suscripciones',
    'payment.onlyPortugueseTitle': 'Pago no disponible',
    'payment.onlyPortugueseAvailable':
      'El pago solo está disponible en portugués en este momento.',
    'payment.blockedInBrazilTitle': 'Pago no disponible en su región',
    'payment.blockedInBrazil':
      'El pago en línea no está disponible para accesos desde Brasil.',
    'payment.blockedContactTitle': 'Contáctenos:',
    'payment.blockedContactBrazil':
      'Brasil\n+55 81 97108 3009 (Teléfono y WhatsApp)\ncontato@livox.com.br\nAvenida Fagundes Varela, 950, LJ 15, CXP 1776, Jardim Atlântico, Olinda-Pe, Brasil, CEP: 53140-080',
    'payment.blockedContactUS':
      'EE.UU.\n+1 (407) 449-6391\ncarlos@livox.com.br\nGrand National Drive, suite 128, Orlando, FL',
    'payment.blockedContactJordan':
      'Jordania\n00962796870058\nala.alramahi@gmail.com',
    'payment.noLicensesEncourage':
      'No tienes licencias. ¡Adquiere ahora para comenzar con Livox!',
    Media: 'Medios',
    'Upload an image or video': 'Subir una imagen o video',
    'No image': 'Sin Imagen',
    'Welcome to your boards page': 'Bienvenido a tu página de tableros',
    'Assistive Tecnology': 'Tecnología Asistiva',
    '1. Create': '1. Crear',
    'To get started use the Livox Studio to create cards, upload images, music and videos':
      'Para comenzar, usa el Livox Studio para crear tarjetas, subir imágenes, música y videos',
    '2. Publish': '2. Publicar',
    'Submit you content to be published in the store':
      'Envía tu contenido para ser publicado en la tienda',
    '3. Get feedback': '3. Obtener Feedback',
    'Receive feedback and satisfaction on seeing your content being used all around the globe!':
      '¡Recibe feedback y satisfacción al ver que tu contenido se está utilizando en todo el mundo!',
    'Livox Portal': 'Portal Livox',
    'A content store made for you!': '¡Una tienda de contenidos hecha para ti!',
    'The best portal of assistive technologies in the world!':
      '¡El mejor portal de tecnologías asistivas del mundo!',
    'Learn More': 'Saber Más',
    'Recent Items': 'Artículos Recientes',
    by: 'por',
    'Untitled Content': 'Contenido sin título',
    'Loading...': 'Cargando...',
    'Click here to add a title': 'Haz clic aquí para agregar un título',
    'Portuguese (BR)': 'Portugués (Brasil)',
    English: 'Inglés',
    Arabic: 'Árabe',
    German: 'Alemán',
    'No boards found': 'No se encontraron tableros',
    'Removing this device will make the user log out of the app. Are you sure you want to remove this device?':
      'Eliminar este dispositivo cerrará la sesión del usuario en la aplicación. ¿Seguro que quieres eliminarlo?',
    'New User': 'Nuevo Usuario',
    'Login as another user': 'Iniciar sesión como otro usuario',
    Technical: 'Técnico',
    Pedagogical: 'Pedagógico',
    Results: 'Resultados',
    'Top Rated Items': 'Artículos Mejor Calificados',
    'Back to Livox Portal': 'Volver al Portal Livox',
    'No Categories': 'Sin categorías',
    Author: 'Autor',
    'No votes yet': 'Aún no hay votos',
    'Rate this content': 'Califica este contenido',
    'You must be logged in to vote on this content!':
      '¡Debes iniciar sesión para votar en este contenido!',
    'Go to Livox Store': 'Ir a la tienda de Livox',
    'Go to Play Store': 'Ir a Play Store',
    'Sign Up': 'Registrarse',
    Login: 'Iniciar sesión',
    'Log In': 'Iniciar sesión',
    'License Availability': 'Disponibilidad de Licencia',
    'My Profile': 'Mi Perfil',
    'No description available': 'No hay descripción disponible',
    Publications: 'Publicaciones',
    'User Profile': 'Perfil de usuario',
    'New user': 'Nuevo usuario',
    'Livox Users Growth': 'Crecimiento de usuarios de Livox',
    'Users Disability Distribution':
      'Distribución de usuarios por discapacidad',
    'Users Disabilty Distribution': 'Distribución de usuarios por discapacidad',
    'Contact us': 'Contáctanos',
    'Support Type': 'Tipo de soporte',
    Subject: 'Asunto',
    Message: 'Mensaje',
    Send: 'Enviar',
    'License Distribution': 'Distribución de licencias',
    'Manage my licenses': 'Gestionar mis licencias',
    'Show From': 'Mostrar de',
    'Only my branch': 'Mi Sucursal',
    'All Branches': 'Todas las Sucursales',
    'Last Validation Date': 'Última fecha de validación',
    'Device ID': 'ID del dispositivo',
    'About you': 'Sobre ti',
    'No publications yet': 'No hay publicaciones aún',
    'No description available.': 'No hay descripción disponible.',
    'Remove this livox user? ': '¿Eliminar este usuario de Livox? ',
    'Users by city': 'Usuarios por ciudad',
    'Create new customer': 'Crear nuevo cliente',
    'Boards Search': 'Buscar tableros',
    'Add a branch to': 'Agregar una sucursal a',
    'Edit Branch': 'Editar una sucursal',
    'Edit Customer': 'Editar cliente',
    Update: 'Actualizar',
    'Delete Branch': 'Eliminar sucursal',
    'Create Branch Administrator': 'Crear administrador de la sucursal',
    'Deleting this branch will remove the users and all licenses from it. Are you sure you want to delete this branch?':
      'Eliminar esta sucursal eliminará a los usuarios y todas las licencias de la misma. ¿Deseas continuar?',
    'Deleting this branch will transfer all users and licenses from this branch and its child branches to the parent branch.':
      'Eliminar esta sucursal transferirá todos los usuarios y licencias de esta sucursal y sus sucursales hijas a la sucursal padre.',
    'Deleting the root branch will remove users, licenses, Livox users and holders of this customer and all its branches.':
      'Eliminar la sucursal raíz eliminará usuarios, licencias, usuarios de Livox y titulares de este cliente y todas sus sucursales.',
    'Are you sure you want to delete this branch?':
      '¿Estás seguro de que deseas eliminar esta sucursal?',
    'Are you sure you want to delete branch':
      '¿Estás seguro de que deseas eliminar la sucursal',
    'Delete all users of this customer and all its branches.':
      'Eliminar todos los usuarios de este cliente y todas sus sucursales.',
    'Delete all licenses of this customer and all its branches.':
      'Eliminar todas las licencias de este cliente y todas sus sucursales.',
    'Delete all Livox users of this customer and all its branches.':
      'Eliminar todos los usuarios de Livox de este cliente y todas sus sucursales.',
    'Delete all holders of this customer and all its branches.':
      'Eliminar todos los titulares de este cliente y todas sus sucursales.',
    'Transfer all users from this branch and its child branches to the parent branch.':
      'Transferir todos los usuarios de esta sucursal y sus sucursales hijas a la sucursal padre.',
    'Transfer all licenses from this branch and its child branches to the parent branch.':
      'Transferir todas las licencias de esta sucursal y sus sucursales hijas a la sucursal padre.',
    'Remove this branch and its child branch structure.':
      'Eliminar esta sucursal y la estructura de sus sucursales hijas.',
    'Reset Password': 'Restablecer Contraseña',
    'years ago': 'años atrás',
    'months ago': 'meses atrás',
    'days ago': 'días atrás',
    'hours ago': 'horas atrás',
    'minutes ago': 'minutos atrás',
    'seconds ago': 'segundos atrás',
    'Livox app is outdated on this device':
      'La aplicación Livox está desactualizada en este dispositivo',
    'Sort By...': 'Ordenar por...',
    'Device Android Id': 'ID del dispositivo',
    Saved: 'Guardado',
    'Saving...': 'Guardando...',
    'Error! Please refresh the page.': '¡Error! Por favor actualiza la página.',
    Review: 'Revisar',
    'Upload an audio or video': 'Subir un audio o video',
    'All Languages': 'Todos los idiomas',
    Portuguese: 'Portugués (Brasil)',
    "By clicking 'Publish' you are agreeing that you have read and accepted our":
      'Al hacer clic en "Publicar" estás aceptando que has leído y aceptado nuestros',
    'terms of use': 'términos de uso',
    'Add a shortcut...': 'Agregar un atajo...',
    ExampleShortcut:
      'Por ejemplo: "¿Qué quieres comer?" para un tablero de alimentos.',
    'Create voice commands to open this board on Livox app!':
      '¡Crea comandos de voz para abrir este tablero en la aplicación Livox!',
    Shortcuts: 'Atajos',
    'NEW!': '¡NUEVO!',
    NEW: 'NUEVO',
    'Uploading...': 'Subiendo...',
    'Processing files...': 'Procesando archivos... Por favor, espera.',
    'The file you uploaded is too large.':
      'El archivo que subiste es demasiado grande.',
    'Error: File too large': 'Error: El archivo es demasiado grande',
    'Error: Sorry we just encoutered an unexpected error, please try again':
      'Error: Lo sentimos, encontramos un error inesperado. Por favor, inténtalo de nuevo',
    'Error: The zip file appears to be corrupted or is not a Livox content':
      'Error: El archivo zip parece estar corrupto o no es un contenido de Livox',
    'Are you sure you want to delete this content?':
      '¿Estás seguro de que deseas eliminar este contenido?',
    'Error: Invalid content, please make sure that the file being uploaded is a .zip file':
      'Error: Contenido inválido, asegúrate de que el archivo que estás subiendo es un archivo .zip',
    'Get Started': 'Comenzar',
    'Record a new shortcut via voice': 'Graba un nuevo atajo usando tu voz',
    'You have blocked this website of using the Microphone.':
      'Has bloqueado este sitio web para usar el micrófono',
    "Couldn't detect speech, please check your microphone settings.":
      'No se detectó habla, por favor verifica la configuración de tu micrófono.',
    'Your browser is not compatible with the Speech Recognition API, but you can manually enter the shortcuts below':
      'Tu navegador no es compatible con la API de reconocimiento de voz, pero puedes introducir los atajos manualmente a continuación.',
    'Error while recording shorcut, please try again':
      'Error al grabar atajo, por favor inténtalo de nuevo.',
    Features: 'Características',
    'Voice Shortcuts': 'Atajos de Voz',
    'Add shortcuts to this folder': 'Agrega atajos a esta carpeta',
    shortcuts: 'atajos',
    'You have pending reviews': 'Tienes revisiones pendientes',
    'No pending reviews': 'Sin revisiones pendientes',
    'Admin Portal': 'Portal de Administración',
    'Log out': 'Cerrar sesión',
    'Zip Overwrite': 'Sobrescribir con Zip',
    Share: 'Compartir',
    'Used Licenses': 'Licencias Usadas',
    'Last Registered Activity': 'Última Actividad Registrada',
    'Interactions by time of day': 'Interacciones por hora del día',
    'Avg. Interactions / User': 'Promedio de Interacciones / Usuario',
    Featured: 'Destacado',
    'Promoted Content': 'Contenido Promocionado',
    'Rate this': 'Califica esto',
    Promote: 'Promocionar',
    'Your rating': 'Tu calificación',
    Play: 'Reproducir',
    'Back to Edit': 'Volver a Editar',
    Next: 'Siguiente',
    'Inside items': 'Artículos internos',
    Regular: 'Regular',
    'Book Mode': 'Modo Libro',
    Fixed: 'Fijado',
    System: 'Sistema',
    Rows: 'Filas',
    Collumns: 'Columnas',
    Display: 'Visualización',
    'Page Mode': 'Modo de Página',
    'Text Size': 'Tamaño del Texto',
    Print: 'Imprimir',
    'This dashboard is made with aggregated data across all licenses':
      'Este panel está hecho con datos agregados de todas las licencias',
    ' assigned to your user': ' asignadas a tu usuario',
    'view licenses': 'ver licencias',
    'No Data': 'Sin Dato',
    'Last 30 days': 'Últimos 30 días',
    'Last 6 months': 'Últimos 6 meses',
    'Last year': 'Último año',
    'Results for': 'Resultados para',
    'Full Screen': 'Pantalla Completa',
    'Cards cut — navigate and paste into empty slots':
      'Tarjetas cortadas — navega y pega en espacios vacíos',
    'No empty slots to paste into': 'No hay espacios vacíos para pegar',
    'Cards pasted': 'Tarjetas pegadas',
    'cards still to paste': 'tarjetas aún por pegar',
    'ready to paste': 'listo para pegar',
    'Paste actions': 'Acciones de pegado',
    'Cards grouped into folder': 'Tarjetas agrupadas en carpeta',
    'Select at least 2 cards to group':
      'Selecciona al menos 2 tarjetas para agrupar',
    'New folder': 'Nueva carpeta',
    Cut: 'Cortar',
    Copy: 'Copiar',
    Paste: 'Pegar',
    'Paste Inside': 'Pegar Dentro',
    Dark: 'Modo Oscuro',
    Light: 'Modo Claro',
    'Card Properties': 'Propiedades del Cartón',
    'Export PDF': 'Exportar PDF',
    'Export as PDF': 'Exportar como PDF',
    'Export section layout': 'Diseño',
    'Export section content': 'Contenido',
    'Standard layout (grid)': 'Diseño estándar (cuadrícula)',
    'Single card (1×1 full page)': 'Tarjeta única (1×1 página completa)',
    'Select card to export': 'Seleccione la tarjeta para exportar',
    'Select a card': 'Seleccione una tarjeta',
    'Current board (grid)': 'Tablero actual (cuadrícula)',
    'Fixed bar only': 'Solo barra fija',
    'Board + Fixed bar': 'Tablero + Barra fija',
    'Main Board': 'Tablero Principal',
    Part: 'Parte',
    'Cut here': 'Corte aquí',
    'Exported on': 'Exportado en',
    'Fixed Bar': 'Barra Fija',
    'Cut for continuous use': 'Cortar para uso continuo',
    'Audio / Video': 'Audio / Video',
    'Add an audio or video': 'Agregar un audio o video',
    'Uploaded image': 'Imagen subida',
    'On touching this board show this image, if none set it will skip the action':
      'Al tocar este tablero, se mostrará esta imagen, si no se configura ninguna, se omitirá la acción',
    'Search an image': 'Busca una imagen',
    Suggestions: 'Sugerencias',
    Images: 'Imágenes',
    Publication: 'Publicación',
    'Manage Boards': 'Gestionar Tableros',
    'Livox Web': 'Livox Web',
    'Settings - Display': 'Configuración - Visualización',
    Start: 'Iniciar',
    Settings: 'Configuración',
    'Manage Users': 'Gestionar Usuarios',
    Voice: 'Voz',
    Controls: 'Controles',
    'Artificial Inteligence': 'Inteligencia Artificial',
    About: 'Acerca de',
    Test: 'Prueba',
    'Voice Language': 'Idioma de la Voz',
    'Voice Actor': 'Actor de Voz',
    'Voice speed': 'Velocidad de la Voz',
    'Pitch Rate': 'Tono de la Voz',
    Preview: 'Previsualizar',
    'Quick chat': 'Charla rápida',
    'Font Size': 'Tamaño de la Fuente',
    'Paging Mode': 'Modo de Paginación',
    'Touch correction': 'Corrección de toque',
    'Time to wait between touches': 'Tiempo de espera entre los toques',
    'Manually set time to prevent any further touches. Set zero seconds to disable.':
      'Configura manualmente el tiempo para prevenir más toques. Establece cero segundos para desactivar.',
    'Natural Conversation': 'Conversación Natural',
    'Trigger words': 'Palabras Clave',
    'Registered keywords that Livox will listen before issuing an action. Keywords are case insensitive.':
      'Palabras clave registradas que Livox escuchará antes de emitir una acción. Las palabras clave no distinguen entre mayúsculas y minúsculas.',
    'No keywords created': 'No hay palabras clave creadas',
    'Speak navigation arrows': 'Hablar las flechas de navegación',
    'Enable natural conversation': 'Habilitar Conversación Natural',
    'Remote voice commands that can show appropriate boards depending on context. Requires a microphone and internet conection.':
      'Comandos de voz remotos que pueden mostrar tableros apropiados dependiendo del contexto. Requiere un micrófono y conexión a Internet.',
    'Enable Intellitouch': 'Habilitar Intellitouch',
    'Recommended for users with motor disabilities. Automatically detects imprect touches.':
      'Recomendado para usuarios con discapacidades motoras. Detecta automáticamente toques imperfectos.',
    'Delay will be set dynamically by Intellitouch.':
      'El retraso se configurará dinámicamente por Intellitouch.',
    Legacy: 'Legado',
    'Livox5+': 'Livox 5.0+',
    'Licenses Status': 'Estado de las Licencias',
    'Activity days': 'Días de Actividad',
    'Active Usage Status': 'Estado de Uso Activo',
    'Above Average': 'Sobre la Media',
    'Below Average': 'Bajo la Media',
    'Average Interactions': 'Promedio de Interacciones: {{clicks}} clics.',
    'Inactive licenses are those in which no user has used Livox in the given period.':
      'Las licencias inactivas son aquellas en las que ningún usuario ha usado Livox en el periodo dado.',
    'Version Status': 'Estado de Versión',
    'Devices with older Operating System (OS) versions are at risk of losing access to Livox.':
      'Los dispositivos con versiones antiguas del Sistema Operativo (OS) están en riesgo de perder acceso a Livox.',
    'Outdated OS': 'OS Desactualizado',
    'Outdated Livox': 'Livox Desactualizado',
    'Operational System Version': 'Versión del Sistema Operativo',
    'Device usage (%)': 'Uso del dispositivo (%)',
    'Device usage': 'Uso del dispositivo',
    'Disability distribution': 'Distribución por discapacidad',
    Period: 'Período',
    '30 days': '30 días',
    '45 days': '45 días',
    '2 months': '2 meses',
    '6 months': '6 meses',
    '1 year': '1 año',
    'Global Active Usage': 'Uso Activo Global',
    'Percent of the users that used above and below global average ({{clicks}} clicks).':
      'Porcentaje de usuarios que utilizaron por encima o por debajo del promedio global ({{clicks}} clics).',
    'Most Active': 'Más Activo',
    'Least Active': 'Menos Activo',
    'The users that used 30% above and below than your average (> {{upper_limit}} and < {{lower_limit}} respectively).':
      'Los usuarios que usaron 30% por encima y por debajo de tu promedio (> {{upper_limit}} y <{{lower_limit}} respectivamente).',
    'Active users are those that had at least 1 interaction on the time period.':
      'Usuarios activos son aquellos que tuvieron al menos 1 interacción en el período.',
    'Activity ({{days}} days)': 'Actividad ({{days}} días)',
    'Dashboard Charts': 'Gráficos del Panel de Control',
    'Users per disability': 'Usuarios por discapacidad',
    'Users per age': 'Usuarios por edad',
    Autism: 'Autismo',
    'Amyotrophic Lateral Sclerosis': 'Esclerosis Lateral Amiotrófica',
    'Cerebral Palsy': 'Parálisis Cerebral',
    'Person without disabilities': 'Persona sin discapacidad',
    'No physical disabilities, just unable to speak':
      'Sin discapacidades físicas, solo incapaz de hablar',
    'Stroke Sequelae': 'Secuelas de un Accidente Cerebrovascular',
    'Down Syndrome': 'Síndrome de Down',
    'Brain Injury': 'Lesión Cerebral',
    'Another motor impairment': 'Otra discapacidad motora',
    'Another cognitive impairment': 'Otra discapacidad cognitiva',
    'Store Statistics': 'Estadísticas de la Tienda',
    Creators: 'Creadores',
    Published: 'Publicados',
    'Unique Downloads': 'Descargas Únicas',
    Items: 'Elementos',
    'SymbolStyx usage': 'Uso de SymbolStix',
    'Uploaded Images': 'Imágenes Subidas',
    'Uploaded Audio/Video': 'Audio/Video Subido',
    'Multiple images': 'Imágenes Múltiples',
    'Most used symbols': 'Símbolos más usados',
    'Usage Status': 'Estado de Uso',
    Disclaimer: 'Aviso',
    'basic plan disclaimer':
      'La licencia BASIC es una versión más simple de Livox, con <b>menos funciones</b> y <b>sin soporte técnico</b>. Normalmente adquirida por padres que conocen bien el Livox y, por ejemplo, desean un segundo dispositivo con menos funciones para que sus hijos lo usen al aire libre. <br/> Esta versión no es recomendada para quienes están comenzando a usar Livox, sino para quienes ya tienen una versión PLUS y desean la BASIC para un segundo dispositivo.',
    'Available Licenses': 'Licencias Disponibles',
    'Unable to log in with provided credentials.':
      'No es posible iniciar sesión con los datos proporcionados.',
    'Renew Licenses': 'Renovar Licencias',
    Border: 'Borde',
    'It is not possible to access cards with more than one state':
      'No es posible acceder a tarjetas con más de un estado',
    'New state': 'Nuevo estado',
    'Only text': 'Solo texto',
    'Livox IntelliBar (Beta)': 'IntelliBar de Livox (Beta)',
    'Print navigation card': 'Imprimir tarjetas de navegación',
    'Board + IntelliBar': 'Tablero + IntelliBar',
    'AI Error': 'Error de IA:',
    'Create items using AI!': '¡Crea elementos usando Inteligencia Artificial!',
    'Get cards recommendations for every situation!':
      '¡Recibe recomendaciones de tarjetas para cada situación!',
    'Examples:': 'Ejemplos:',
    'Breakfast items': 'Elementos del desayuno',
    'Teeth brushing steps': 'Pasos para cepillarse los dientes',
    'Quiz option choices': 'Opciones de preguntas de un cuestionario',
    'and many more!': '¡y muchos más!',
    'Cards suggestion with AI': 'Sugerencias de tarjetas con IA',
    '{{used}} of {{limit}} used': '{{used}} de {{limit}} usados',
    'Insufficient JandaIA coins': 'Saldo de JandaIA Coins insuficiente',
    'Type a topic': 'Escribe un tema',
    'Add card': 'Añadir tarjeta',
    'Card added to board': 'Tarjeta añadida al tablero',
    'No empty slots available': 'No hay espacios vacíos disponibles',
    'Failed to add card': 'Error al añadir la tarjeta',
    'Print all pages': 'Imprimir todas las páginas',
    "Are you sure you want to delete the card(s)? This can't be undone!":
      '¿Estás seguro de que deseas eliminar la(s) tarjeta(s)? ¡Esto no se puede deshacer!',
    'Edit Email': 'Editar Correo',
    'Already exists an user with informed email':
      'Ya existe un usuario registrado con el correo proporcionado',
    'Default Payment': 'Pago predeterminado',
    'ending with': 'terminado en',
    'Expires at': 'Expira en',
    'Plan details': 'Detalles de los planes',
    "Passwords don't match": 'Las contraseñas no coinciden',
    'Password must contain at least one uppercase letter, one lowercase letter, one special character, one number, and have a minimum length of 8 characters':
      'La contraseña debe contener al menos una letra mayúscula, una letra minúscula, un carácter especial, un número y tener una longitud mínima de 8 caracteres',
    'User Already exists': 'El usuario ya existe',
    'An email will be sent to activate the account':
      'Se enviará un correo para activar la cuenta',
    'Expire month': 'Mes de expiración',
    'Expire year': 'Año de expiración',
    'Select as default payment method':
      'Seleccionar como método de pago predeterminado',
    'Change Billing': 'Cambiar datos de facturación',
    'Change card details': 'Cambiar detalles de la tarjeta',
    activate_license: 'Activar Licencia',
    'Change Livox Plan': 'Cambiar plan de Livox',
    'Due next in': 'Vencimiento el próximo día',
    'Cancel motive': 'Motivo de la cancelación',
    'Are you sure you want to cancel the plan?':
      '¿Estás seguro de que deseas cancelar el plan?',
    Card: 'Tarjeta',
    'My subscriptions': 'Mis suscripciones',
    Cards: 'Tarjetas',
    'Welcome to Livox': 'Bienvenido a Livox',
    'enter your e-mail address': 'introduce tu dirección de correo',
    'enter your password': 'introduce tu contraseña',
    'Password requirements': 'Requisitos de la contraseña',
    'Must be at least 8 characters long': 'Debe tener al menos 8 caracteres',
    'Must include at least one uppercase letter':
      'Debe incluir al menos una letra mayúscula',
    'Must include at least one lowercase letter':
      'Debe incluir al menos una letra minúscula',
    'Must include at least one number': 'Debe incluir al menos un número',
    'Must include at least one special character':
      'Debe incluir al menos un carácter especial',
    'Old Password': 'Contraseña Antigua',
    'New Password': 'Nueva Contraseña',
    'enter your old password': 'introduce tu contraseña antigua',
    'enter your new password': 'introduce tu nueva contraseña',
    'confirm your new password': 'confirma tu nueva contraseña',
    'Holder Information': 'Información del Titular',
    Client: 'Cliente',
    'My Subscriptions': 'Mis Suscripciones',
    'Payment Methods': 'Métodos de Pago',
    'Payment History': 'Historial de Pagos',
    'Livox Cloud': 'Nube de Livox',
    'of 1TB used': 'de 1TB usados',
    'Portal Livox': 'Portal Livox',
    'CONGRATS!': '¡FELICIDADES!',
    'Based on your stats you used your account':
      'Basado en tus estadísticas, has usado tu cuenta',
    'more than last month!': '¡más que el mes pasado!',
    'Regional Food': 'Comida Regional',
    Animals: 'Animales',
    'The Flash Game': 'El Juego Flash',
    'All users': 'Todos los usuarios',
    'All period': 'Todo el período',
    'Last day': 'Último día',
    'Last week': 'Última semana',
    'Last month': 'Último mes',
    '1 month': '1 mes',
    'User Stats': 'Estadísticas del Usuario',
    'Play Games': 'Jugar Juegos',
    'Play Duration': 'Duración de Uso',
    '(minutes)': '(minutos)',
    Recommendations: 'Recomendaciones',
    'Shared Content': 'Contenido Compartido',
    'Total number of minutes:': 'Número total de minutos:',
    'Yes or No': 'Sí o No',
    Fruits: 'Frutas',
    Food: 'Comida',
    'Monthly Usage': 'Uso Mensual',
    'Amount of Interactions': 'Cantidad de Interacciones',
    "Oops! It looks like you haven't shared any content yet.":
      '¡Ups! Parece que aún no has compartido ningún contenido.',
    'Edit Your Profile': 'Edita Tu Perfil',
    Appearance: 'Apariencia',
    'Privacy Terms': 'Términos de Privacidad',
    'Service Terms': 'Términos de Servicio',
    'Password Settings': 'Configuración de Contraseña',
    'For up to 3 users who already know or follow up with Livox professionals.':
      'Para hasta 3 usuarios que ya conocen o siguen con profesionales de Livox.',
    '/MONTH': '/MES',
    'Payment Method': 'Método de Pago',
    IntelliTouch: 'IntelliTouch',
    'Image Dataset': 'Banco de Imágenes',
    'Current Plan': 'Plan Actual',
    'Other Subscriptions': 'Otras Suscripciones',
    cancel: 'Cancelar',
    cpfOrCnpj: 'CPF o CNPJ',
    processing: 'Procesando...',
    tryAgainIn: 'Inténtelo de nuevo en {{seconds}}s',
    'BASIC SUBSCRIPTION': 'SUSCRIPCIÓN BÁSICA',
    'Basic Subscription': 'Suscripción Básica',
    'See as list': 'Ver como lista',
    'See as grid': 'Ver como cuadrícula',
    'HOW IT WORKS?': '¿CÓMO FUNCIONA?',
    '.zip upload': 'subida .zip',
    'create board': 'crear tablero',
    create: 'crear',
    upload: 'subir',
    feedback: 'retroalimentación',
    'To get started, use Livox Studio to create cards, upload images, music and videos!':
      '¡Para comenzar, usa Livox Studio para crear tarjetas, subir imágenes, música y videos!',
    'Submit you content to be published in the portal!':
      '¡Envía tu contenido para ser publicado en el portal!',
    'Receive feedback and satisfaction ratings knowing your boards are being used around the world!':
      '¡Recibe retroalimentación y calificaciones de satisfacción sabiendo que tus tableros se están utilizando en todo el mundo!',
    Price: 'Precio',
    OK: 'OK',
    PENDING: 'PENDIENTE',
    DECLINED: 'RECHAZADO',
    ChangeLivoxPlan: 'Cambiar plan de Livox',
    'Active Plans': 'Planes activos',
    'Canceled Plans': 'Planes cancelados',
    'Are you sure you want to cancel the plan':
      '¿Estás seguro de que deseas cancelar el plan?',
    'Plan changed successfully': 'Plan cambiado con éxito',
    'Plan cancel successfully': 'Plan cancelado con éxito',
    'Provide the reason for cancellation':
      'Proporciona el motivo de la cancelación',
    CHANGE: 'CAMBIAR',
    paid: 'pagado',
    open: 'pendiente',
    draft: 'borrador',
    void: 'anulado',
    declined: 'rechazado',
    uncollectible: 'incobrable',
    Invoices: 'Facturas',
    'Wrong password.': 'Contraseña incorrecta.',
    "The two password fields didn't match.":
      'Los dos campos de contraseña no coinciden.',
    'Something went wrong.': 'Algo salió mal.',
    'Please fill in all required fields.':
      'Por favor, complete todos los campos obligatorios.',
    'Password changed successfully!': '¡Contraseña cambiada con éxito!',
    'Device Nickname': 'Apodo del Dispositivo',
    'License Information': 'Información de la Licencia',
    to: 'a',
    'Licenses per page': 'Licencias por página',
    'Choose a payment method': 'Elige un método de pago',
    'Published Content': 'Contenido Publicado',
    'View published content in the store':
      'Ver contenidos publicados en la tienda',
    'Payment Method changed successfully':
      'Método de pago actualizado con éxito',
    'Device removed successfully': 'Dispositivo eliminado con éxito',
    'Failed to remove device': 'Error al eliminar el dispositivo',
    Monday: 'Lunes',
    Tuesday: 'Martes',
    Wednesday: 'Miércoles',
    Thursday: 'Jueves',
    Friday: 'Viernes',
    Saturday: 'Sábado',
    Sunday: 'Domingo',
    'Evolution of use': 'Evolución del uso',
    'Use by schedule': 'Uso por horarios del día',
    '(clicks)': '(clics)',
    Responsible: 'Responsable',
    Birthday: 'Fecha de Nacimiento',
    Birthdate: 'Fecha de Nacimiento',
    None: 'Ninguno',
    Mild: 'Leve',
    Moderate: 'Moderado',
    'Severe (Blindness)': 'Severo (Ceguera)',
    Good: 'Bueno',
    'Severe (Needs switch)': 'Grave (Necesita interruptor)',
    'Few physical limitations': 'Pocas limitaciones físicas',
    'Dificulties in daily activities, requires assistance':
      'Dificultades en actividades diarias, requiere asistencia',
    'Almost or totally dependent': 'Casi o totalmente dependiente',
    'Without communicative intent': 'Sin intención comunicativa',
    'Does not verbalize, but has communicative intention':
      'No verbaliza, pero tiene intención comunicativa',
    'Make sounds': 'Hace sonidos',
    'Makes vowel unions': 'Hace unión de vocales',
    'Speak with very limited vocabulary (5-10 words)':
      'Habla con vocabulario muy limitado (5-10 palabras)',
    'Speak with limited vocabulary (10-30 words)':
      'Habla con vocabulario limitado (10-30 palabras)',
    'Fully communicative': 'Totalmente comunicativo',
    'Diagnosis Information': 'Información del Diagnóstico',
    'Fine motor skills': 'Habilidades motoras finas',
    'Repetitive movements': 'Movimientos repetitivos',
    'Hearing impairment': 'Deficiencia auditiva',
    'Visual impairment': 'Deficiencia visual',
    'Current communication': 'Comunicación actual',
    'Autonomy level': 'Nivel de autonomía',
    Have: 'Tiene',
    'Does not have': 'No tiene',
    Yes: 'Sí',
    No: 'No',
    'Customer Admin': 'Administrador del Cliente',
    'Portal Admin': 'Administrador del Portal',
    'Users per page': 'Usuarios por página',
    Private: 'Privado',
    Organization: 'Organización',
    'License Usage': 'Uso de Licencias',
    'Livox Usage': 'Uso de Livox',
    Amount: 'Cantidad',
    Used: 'Utilizado',
    'Users Status': 'Estado de los usuarios',
    'active users': 'usuarios activos',
    Disability: 'Discapacidad',
    'Portal Users': 'Usuarios del Portal',
    'Last Validation': 'Última Validación',
    Subscriptions: 'Suscripciones',
    'Public?': '¿Público?',
    'Avaiable?': '¿Disponible?',
    'Searching for boards from all your users':
      'Buscando tableros de todos tus usuarios',
    'Your filters did not find results':
      'Tus filtros no encontraron resultados',
    'not found': 'no encontrado',
    "It looks like your users haven't created boards yet":
      'Parece que tus usuarios aún no han creado tableros',
    'no boards': 'sin tableros',
    'Searching for your boards': 'Buscando tus tableros',
    'Find boards created by users in your organization here':
      'Encuentra aquí los tableros creados por usuarios de tu organización',
    'Removing this devices will make the user log out of the app. Are you sure you want to remove {{count}} device?':
      'Eliminar estos dispositivos cerrará la sesión del usuario en la aplicación. ¿Estás seguro de que quieres eliminar {{count}} dispositivo?',
    'Removing this device will make the user log out of the app. Are you sure you want to remove this devices?':
      'Eliminar este dispositivo cerrará la sesión del usuario en la aplicación. ¿Estás seguro de que quieres eliminar este dispositivo?',
    '{{count}} devices removed successfully':
      '{{count}} dispositivos eliminados con éxito',
    '{{count}} devices failed to be removed':
      '{{count}} dispositivos no pudieron ser eliminados',
    'Branch removed successfully': 'Sucursal eliminada con éxito',
    'Failed to remove branch': 'Error al eliminar la sucursal',
    'Branches moved successfully': 'Sucursales movidas con éxito',
    'Failed to move branches': 'Error al mover las sucursales',
    'Move branches to:': 'Mover sucursales a:',
    Move: 'Mover',
    'Some selected branches have sub-branches. All sub-branches will also be moved.':
      'Algunas sucursales seleccionadas tienen sub-sucursales. Todas las sub-sucursales también serán movidas.',
    'Parent Branch': 'Sucursal principal',
    Root: 'Raíz',
    'Sub-branch of': 'Sub-sucursal de',
    'Branch created successfully!': '¡Sucursal creada con éxito!',
    'Email already registered': 'Correo ya registrado',
    'Branch updated successfully!': '¡Sucursal actualizada con éxito!',
    'Create Branch': 'Crear Sucursal',
    'Update Branch': 'Editar Sucursal',
    'Edit Publication': 'Editar Publicación',
    'My Assessments': 'Mis Evaluaciones',
    'Assessments Details': 'Detalles de las Evaluaciones',
    Assessment: 'Evaluación',
    'Assessments per page': 'Evaluaciones por página',
    Finish: 'Finalizar',
    'General assessment': 'Evaluación general',
    'Temporal assessment': 'Evaluación temporal',
    'Assessment average': 'Promedio de Evaluación',
    Cognitive: 'Cognitivo',
    Auditory: 'Auditivo',
    Visual: 'Visual',
    Oral: 'Oral',
    Behaviour: 'Comportamental',
    Geral: 'General',
    'Add comment': 'Agregar comentario',
    'Enter your comment for this assessment':
      'Introduce tu comentario para esta evaluación',
    'Assessment added successfully!': '¡Evaluación añadida con éxito!',
    'Failed to add assessments': 'Error al añadir evaluación',
    'New assessment': 'Nueva evaluación',
    'Customer Support': 'Soporte al Cliente',
    Promoted: 'Promovido',
    Statistics: 'Estadísticas',
    Details: 'Detalles',
    Refuse: 'Rechazar',
    Approve: 'Aprobar',
    'Content Details': 'Detalles del Contenido',
    'boards per page': 'tableros por página',
    'Searching for pending content...': 'Buscando contenido pendiente...',
    'Searching for promoted content...': 'Buscando contenido promovido...',
    'Searching for published content...': 'Buscando contenido publicado...',
    Created: 'Creado',
    Demote: 'Degradar',
    'Demote Publication': 'Degradar Publicación',
    'Do you want to demote this content?': '¿Deseas degradar este contenido?',
    'Approve Publication': 'Aprobar Publicación',
    'Do you approve this publication?': '¿Apruebas esta publicación?',
    'Original language': 'Idioma original',
    'Translate into (optional)': 'Traducir a (opcional)',
    'The board was written in this language, not the one it was submitted as — the existing content will be relabeled, not translated.':
      'El tablero fue escrito en este idioma, no en el idioma con el que se envió; el contenido existente se volverá a etiquetar, no se traducirá.',
    'Reject Publication': 'Rechazar Publicación',
    'Enter the comment for this rejection':
      'Introduce el comentario para este rechazo',
    'Remove Publication': 'Eliminar Publicación',
    'Download count': 'Cuenta de descargas',
    'Successfully promoted!': '¡Promocionado con éxito!',
    'An error occurred while promoting.': 'Ocurrió un error al promocionar.',
    'Upload a banner to promote this board.':
      'Sube un banner para promocionar este tablero.',
    'Successfully published board!': '¡Tablero publicado con éxito!',
    'Successfully updated board!!': '¡Tablero actualizado con éxito!',
    'An error occurred while submitting.': 'Ocurrió un error al enviar.',
    'Increase the description to at least 10 characters.':
      'Amplía la descripción a al menos 10 caracteres.',
    'Publish board': 'Publicar tablero',
    'Board submitted for review!': '¡Tablero enviado a revisión!',
    'Please upload a cover image.': 'Sube una imagen de portada.',
    'The board will be reviewed by an administrator before it appears in the store.':
      'El tablero será revisado por un administrador antes de aparecer en la tienda.',
    'Enter description': 'Introduce una descripción',
    'Enter title': 'Introduce el título',
    'Enter subtitle': 'Introduce el subtítulo',
    Subtitle: 'Subtítulo',
    'Email successfully sent!!!': '¡Correo enviado con éxito!',
    'Error sending email!': '¡Error al enviar correo!',
    'The content has been demoted!': '¡El contenido ha sido degradado!',
    'Failed to demote content!': '¡Error al degradar contenido!',
    'Publication successfully approved!': '¡Publicación aprobada con éxito!',
    'Failed to approve!': '¡Error al aprobar!',
    'Publication successfully rejected!': '¡Publicación rechazada con éxito!',
    'Failed to reject!': '¡Error al rechazar!',
    Activity: 'Actividad',
    'License Activity': 'Actividad de Licencias',
    'Active Licenses': 'Licencias Activas',
    'Inactive Licenses': 'Licencias Inactivas',
    'User Activity': 'Actividad de Usuarios',
    'Removing this sponsor will revoke access to the dashboard and clear all licenses assigned to them.':
      'Eliminar este patrocinador revocará el acceso al panel y limpiará todas las licencias asignadas.',
    'Are you sure you want to delete this sponsor?':
      '¿Estás seguro de que deseas eliminar este patrocinador?',
    'The sponsor has been deleted!': '¡El patrocinador ha sido eliminado!',
    'Failed to remove sponsor!': '¡Error al eliminar patrocinador!',
    'Sponsor created successfully!': '¡Patrocinador creado con éxito!',
    'Sponsor updated successfully!': '¡Patrocinador actualizado con éxito!',
    'Edit Sponsor': 'Editar Patrocinador',
    'Create Sponsor': 'Crear Patrocinador',
    'enter sponsor name...': 'introduce el nombre del patrocinador...',
    'enter email...': 'introduce el correo...',
    'New Sponsor': 'Nuevo Patrocinador',
    Sponsors: 'Patrocinadores',
    'Projects Details': 'Detalles de los Proyectos',
    'Project Dashboard': 'Panel de Control del Proyecto',
    'Sponsors per page': 'Patrocinadores por página',
    'Assign Licenses': 'Asignar Licencias',
    '{{count}} licenses successfully assigned':
      '{{count}} licencias asignadas con éxito',
    'Failed to assign licenses': 'Error al asignar licencias',
    'Assign licenses to sponsor': 'Asignar licencias al patrocinador',
    'Sponsor Licenses': 'Licencias del Patrocinador',
    'Sponsored Projects': 'Proyectos Patrocinados',
    'Remove Licenses': 'Eliminar Licencias',
    'Remove licenses from sponsor': 'Eliminar licencias del patrocinador',
    '{{count}} licenses successfully removed':
      '{{count}} licencias eliminadas con éxito',
    'Failed to remove licenses': 'Error al eliminar licencias',
    'Create Portal User': 'Crear Usuario del Portal',
    'enter first name...': 'introduce el primer nombre...',
    'enter last name...': 'introduce el apellido...',
    'enter a password...': 'introduce una contraseña...',
    'You do not have active plans': 'No tienes planes activos',
    'You do not have canceled plans': 'No tienes planes cancelados',
    'searching for your payment methods': 'buscando tus métodos de pago',
    'You have no payment methods': 'No tienes métodos de pago',
    failed: 'fallido',
    'Your token is invalid or has expired':
      'Tu token es inválido o ha expirado',
    'Password does not meet the minimum security requirements':
      'La contraseña no cumple con los requisitos mínimos de seguridad',
    'Passwords do not match.': 'Las contraseñas no coinciden.',
    'Resetting...': 'Restableciendo...',
    'validating your token': 'validando tu token',
    'Password successfully changed!': '¡Contraseña cambiada con éxito!',
    'Error changing password!': '¡Error al cambiar la contraseña!',
    'enter branch name': 'introduce el nombre de la sucursal',
    'enter branch address': 'introduce la dirección de la sucursal',
    'enter customer name': 'introduce el nombre del cliente',
    'enter customer address': 'introduce la dirección del cliente',
    'enter city': 'introduce la ciudad',
    'enter zip code': 'introduce el código postal',
    'enter state': 'introduce el estado',
    'enter phone number': 'introduce el número de teléfono',
    'Unauthorized Access': 'Acceso no autorizado',
    'You do not have permission to view this page with your current role.':
      'No tienes permiso para ver esta página con tu rol actual.',
    'Page Not Found': 'Página no encontrada',
    'Sorry, the page you are looking for doesn’t exist.':
      'Lo sentimos, la página que buscas no existe.',
    'Este campo no puede ser en blanco.':
      'Este campo no puede estar en blanco.',
    'no licenses': 'sin licencias',
    'You do not have any licenses available.':
      'No tienes ninguna licencia disponible.',
    licenses: 'licencias',
    users: 'usuarios',
    Quantity: 'Cantidad',
    Indicator: 'Indicador',
    Value: 'Valor',
    Category: 'Categoría',
    Aggregate: 'Agregar',
    'Customers per page': 'Clientes por página',
    'Holders per page': 'Titulares por página',
    'Searching for your licenses': 'Buscando tus licencias',
    'There are no promoted boards': 'No hay tableros promovidos',
    'There are no pending boards': 'No hay tableros pendientes',
    'No data was found for this chart.':
      'No se encontraron datos para este gráfico.',
    Sponsor: 'Patrocinador',
    'My Projects': 'Mis Proyectos',
    'Invalid Date': 'Fecha Inválida',
    'Organization Details': 'Detalles de la Organización',
    'All Licenses': 'Todas las Licencias',
    'All License Types': 'Todos los Tipos de Licencia',
    'Select Branch': 'Seleccionar Sucursal',
    'Unlink Licenses': 'Desvincular Licencias',
    'Unlink License': 'Desvincular Licencia',
    'Licenses transferred with success!': '¡Licencias transferidas con éxito!',
    'Error in transfer!': '¡Error en la transferencia!',
    'An unexpected error occurred!': '¡Ocurrió un error inesperado!',
    'Transfer licenses to:': 'Transferir licencias a:',
    'When deleting this user from the Portal, they will remain available on your Livox tablet. If you don’t want this user’s data to be sent back to the Portal, delete them from your tablet as well.':
      'Al eliminar este usuario del Portal, permanecerá disponible en tu tablet Livox. Si no deseas que los datos de este usuario se envíen nuevamente al Portal, elimínalo también de tu tablet.',
    'The Livox User has been deleted!':
      '¡El Usuario de Livox ha sido eliminado!',
    'Failed to remove Livox User!': '¡Error al eliminar el Usuario de Livox!',
    'Delete Livox User': 'Eliminar Usuario de Livox',
    'Are you sure you want to delete this livox user?':
      '¿Estás seguro de que deseas eliminar este usuario de Livox?',
    'Activate with QRCode': 'Activar con QRCode',
    'Enter a valid holder email': 'Introduce un correo de titular válido',
    'To activate this license, enter the email of an associated holder.':
      'Para activar esta licencia, introduce el correo de un titular asociado.',
    'Holder Email': 'Correo del Titular',
    'Invalid email or not associated with this license.':
      'Correo inválido o no asociado a esta licencia.',
    Validate: 'Validar',
    'Activate with QRCode in your Livox app':
      'Activa con QRCode en tu aplicación Livox',
    Distributor: 'Distribuidor',
    'Distributor Admin': 'Administrador de Distribuidor',
    'Distributor Support': 'Soporte de Distribuidor',
    'Create Support Area': 'Crear Área de Soporte',
    'enter support area name...': 'introduce el nombre del área de soporte...',
    'Support area created successfully!': '¡Área de Soporte creada con éxito!',
    'Support area updated successfully!':
      '¡Área de Soporte actualizada con éxito!',
    'Edit Support Area': 'Editar Área de Soporte',
    'Removing this support area will only unlink customers and users from this area.':
      'Eliminar esta área de soporte solo desvinculará clientes y usuarios de esta área.',
    'Are you sure you want to delete this support area?':
      '¿Estás seguro de que deseas eliminar esta área de soporte?',
    'The support area has been deleted!':
      '¡El área de soporte ha sido eliminada!',
    'Failed to remove support area!': '¡Error al eliminar el área de soporte!',
    'Support Area Users': 'Usuarios del Área de Soporte',
    'Remove Users': 'Eliminar Usuarios',
    'Remove users from support area': 'Eliminar usuarios del área de soporte',
    'Failed to remove users': 'Error al eliminar usuarios',
    'Select Users': 'Seleccionar Usuarios',
    '{{count}} users successfully removed':
      '{{count}} usuarios eliminados con éxito',
    'Support Area Customers': 'Clientes del Área de Soporte',
    'Select Customers': 'Seleccionar Clientes',
    'Customers added successfully!': '¡Clientes añadidos con éxito!',
    'Remove Customers': 'Eliminar Clientes',
    '{{count}} customers successfully removed':
      '{{count}} clientes eliminados con éxito',
    'Failed to remove customers': 'Error al eliminar clientes',
    'Remove customers from support area':
      'Eliminar clientes del área de soporte',
    Add: 'Agregar',
    'Support Areas per page': 'Áreas de Soporte por página',
    'Created at': 'Creado el',
    'Confirm delete': 'Confirmar eliminación',
    'Android Versions': 'Versiones Android',
    'Create Android Version': 'Crear Versión Android',
    'Edit Android Version': 'Editar Versión Android',
    'New Android Version': 'Nueva Versión Android',
    'Android version created successfully!':
      '¡Versión Android creada con éxito!',
    'Android version updated successfully!':
      '¡Versión Android actualizada con éxito!',
    'The android version has been deleted!':
      '¡La versión Android ha sido eliminada!',
    'Failed to remove android version!':
      '¡Error al eliminar la versión Android!',
    'Are you sure you want to delete this android version?':
      '¿Está seguro de que desea eliminar esta versión Android?',
    'Android Versions per page': 'Versiones Android por página',
    Resellers: 'Revendedores',
    'Create Reseller': 'Crear Revendedor',
    'Edit Reseller': 'Editar Revendedor',
    'New Reseller': 'Nuevo Revendedor',
    'enter reseller name...': 'ingrese el nombre del revendedor...',
    'Reseller created successfully!': '¡Revendedor creado con éxito!',
    'Reseller updated successfully!': '¡Revendedor actualizado con éxito!',
    'The reseller has been deleted!': '¡El revendedor ha sido eliminado!',
    'Failed to remove reseller. Make sure there are no licenses linked to it before deleting.':
      'Error al eliminar el revendedor. Asegúrese de que no haya licencias vinculadas antes de eliminarlo.',
    'Are you sure you want to delete this reseller?':
      '¿Está seguro de que desea eliminar este revendedor?',
    'Resellers per page': 'Revendedores por página',
    'Payment QR Code': 'Código QR de pago',
    'Payment link for {{name}}': 'Enlace de pago para {{name}}',
    'Payment link': 'Enlace de pago',
    'User created successfully!': '¡Usuario creado con éxito!',
    Spanish: 'Español',
    'Billing user does not exist': 'El usuario de facturación no existe',
    French: 'Francés',
    Italian: 'Italiano',
    'Our website has been updated to improve your experience. To ensure proper functionality, we recommend clearing your browser cache. If you are using the Livox app version 5, please close and reopen the app to ensure proper connection to your account.':
      'Nuestro sitio web ha sido actualizado para mejorar su experiencia. Para asegurar un funcionamiento correcto, le recomendamos que limpie la caché de su navegador. Si está utilizando la versión 5 de la aplicación Livox, cierre y vuelva a abrir la aplicación para garantizar la conexión adecuada a su cuenta.',
    'Website Update': 'Actualización del sitio web',
    'Reload page': 'Recargar página',
    "Don't show again": 'No mostrar de nuevo',
    'enter email': 'introduce correo',
    'Customer created successfully!': '¡Cliente creado con éxito!',
    'Enter a valid email address': 'Introduce una dirección de correo válida',
    'Only letters are allowed': 'Solo se permiten letras',
    'enter number of devices': 'introduce número de dispositivos',
    'enter text': 'introduce texto',
    'enter install key...': 'introduce la clave de instalación...',
    'enter device name...': 'introduce el nombre del dispositivo...',
    'enter device nickname...': 'introduce el apodo del dispositivo...',
    'enter device MAC address...':
      'introduce la dirección MAC del dispositivo...',
    'Device MAC Address': 'Dirección MAC del Dispositivo',
    'Licenses created successfully!': '¡Licencias creadas con éxito!',
    Payment: 'Pago',
    'Registration link generated successfully!':
      'Link de registro generado con éxito!',
    'Failed to generate registration link.':
      '¡Error al generar el link de registro!',
    'Copy Link': 'Copiar Link',
    'Link copied to clipboard!': '¡Link copiado al portapapeles!',
    '{{diff}} year(s) ago': 'hace {{diff}} año(s)',
    '{{diff}} month(s) ago': 'hace {{diff}} mes(es)',
    '{{diff}} day(s) ago': 'hace {{diff}} día(s)',
    '{{diff}} hour(s) ago': 'hace {{diff}} hora(s)',
    '{{diff}} minute(s) ago': 'hace {{diff}} minuto(s)',
    'Holder registered successfully!': '¡Titular registrado con éxito!',
    'Register Holder': 'Crear Titular',
    'enter address': 'introduce dirección',
    'confirm your password': 'confirma tu contraseña',
    'Passwords must match': 'Passwords must match',
    'Professional Type': 'Tipo de Profesional',
    'Speech Therapist': 'Terapeuta del Habla',
    'Occupational Therapist': 'Terapeuta Ocupacional',
    Physiotherapist: 'Fisioterapeuta',
    Teacher: 'Profesor',
    Pedagogue: 'Pedagogo',
    Psychopedagogue: 'Psicopedagogo',
    Other: 'Otro',
    'Error loading subscription details':
      'Error al cargar detalles de la suscripción',
    Activation: 'Activación',
    Cancellation: 'Cancelación',
    'Due Date': 'Fecha de Vencimiento',
    'Payment Link': 'Link de Pago',
    Receipt: 'Recibo',
    'View Receipt': 'Ver Recibo',
    'Invoice Date': 'Fecha de la Factura',
    Paid: 'Pagado',
    'Invoice Status': 'Estado de la Factura',
    'Receipt Link': 'Link del Recibo',
    'Status updated successfully': 'Estado actualizado con éxito',
    'Failed to update license status': 'Error al actualizar el estado',
    'Edit License': 'Editar Licencia',
    'Are you sure you want to delete this license?':
      '¿Está seguro de que desea eliminar esta licencia?',
    'Are you sure you want to delete license':
      '¿Está seguro de que desea eliminar la licencia',
    'This will delete all licenses with install key: {{installKey}}':
      'Esto eliminará todas las licencias con la clave de instalación: {{installKey}}',
    'Permanently delete the license(s)':
      'Eliminar permanentemente la(s) licencia(s)',
    'License deleted successfully!': '¡Licencia eliminada con éxito!',
    'Failed to delete license!': '¡Error al eliminar la licencia!',
    'License updated successfully!': '¡Licencia actualizada con éxito!',
    'Failed to update license!': '¡Error al actualizar la licencia!',
    'No changes to save': 'No hay cambios para guardar',
    'Are you sure you want to update all licenses?':
      '¿Está seguro de que desea actualizar todas las licencias?',
    'This will update all licenses with install key':
      'Esto actualizará todas las licencias con la clave de instalación',
    'Update install key to': 'Actualizar clave de instalación a',
    'Update type to': 'Actualizar tipo a',
    'All licenses with this install key will be affected!':
      '¡Todas las licencias con esta clave de instalación se verán afectadas!',
    'Click here': 'Clique aquí',
    Donation: 'Donación',
    Sale: 'Venta',
    Evaluation: 'Evaluación',
    Research: 'Investigación',
    'Old Version (BETA TEST)': 'Versión Antigua (TEST BETA)',
    Developer: 'Desarrollador',
    Representative: 'Representante',
    'Resale Channel': 'Canal de Reventa',
    'Are you sure you want to unblock this customer?':
      '¿Estás seguro de que deseas desbloquear este cliente?',
    'Are you sure you want to block this customer?':
      '¿Estás seguro de que deseas bloquear este cliente?',
    Block: 'Bloquear',
    'Change Status': 'Cambiar Estado',
    'Are you sure you want to change the status?':
      '¿Está seguro de que desea cambiar el estado?',
    Select: 'Seleccionar',
    'Unit manager': 'Gerente de unidad',
    'type to search': 'escriba para buscar',
    'Manager e-mail': 'E-mail del gerente',
    'Create user': 'Crear usuario',
    'Cancel user creation': 'Cancelar creación de usuario',
    'Select existing user': 'Seleccionar usuario existente',
    'enter password': 'ingrese la contraseña',
    'confirm password': 'confirme la contraseña',
    'Select a manager or create a new user':
      'Seleccione un gerente o cree un nuevo usuario',
    'Email not found. Click Create user':
      'E-mail no encontrado. Haga clic en Crear usuario',
    'This email already exists. Select an existing user':
      'Este e-mail ya existe. Seleccione un usuario existente',
    'Customer email already registered.':
      'El correo electrónico del cliente ya está registrado.',
    'Email is required': 'E-mail es obligatorio',
    'Invalid value': 'Valor inválido',
    'This field is required': 'Este campo es obligatorio',
    'Password is required': 'Contraseña es obligatoria',
    'Confirm Exit': 'Confirmar Salida',
    'Are you sure you want to exit? Any unsaved changes will be lost.':
      '¿Está seguro de que desea salir? Se perderán los cambios no guardados.',
    Export: 'Exportar',
    'Export Charts': 'Exportar Gráficos',
    'Export Charts to PDF': 'Exportar Gráficos a PDF',
    'Export Data': 'Exportar Datos',
    'Exporting...': 'Exportando...',
    'No data to export': 'Sin datos para exportar',
    'No charts found to export': 'No se encontraron gráficos para exportar',
    'File exported successfully': 'Archivo exportado con éxito',
    'Charts exported successfully': 'Gráficos exportados con éxito',
    'Export successful!': '¡Exportación exitosa!',
    'Export failed!': '¡Error en la exportación!',
    'Error exporting file': 'Error al exportar archivo',
    'Error exporting charts': 'Error al exportar gráficos',
    'Are you sure you want to delete this user?':
      '¿Está seguro de que desea eliminar este usuario?',
    'Are you sure you want to delete user':
      '¿Está seguro de que desea eliminar el usuario',
    'This action will:': 'Esta acción:',
    'Unlink all licenses from the user holder':
      'Desvinculará todas las licencias del titular del usuario',
    'Delete the associated holder (if exists)':
      'Eliminará el titular asociado (si existe)',
    'Remove user from all groups': 'Eliminará al usuario de todos los grupos',
    'Delete all Livox Users linked to this user':
      'Eliminará todos los Usuarios de Livox vinculados a este usuario',
    'Permanently delete the user account':
      'Eliminará permanentemente la cuenta del usuario',
    'This action cannot be undone!': '¡Esta acción no se puede deshacer!',
    'User updated successfully!': '¡Usuario actualizado con éxito!',
    'User deleted successfully!': '¡Usuario eliminado con éxito!',
    '{{count}} licenses unlinked.': '{{count}} licencias desvinculadas.',
    'Holder deleted.': 'Titular eliminado.',
    'Failed to delete user!': '¡Error al eliminar usuario!',
    'Changing password for user': 'Cambiando contraseña para el usuario',
    'enter new password...': 'ingrese nueva contraseña...',
    'confirm new password...': 'confirme nueva contraseña...',
    'Update Password': 'Actualizar Contraseña',
    'Password updated successfully!': '¡Contraseña actualizada con éxito!',
    'confirm your password...': 'confirme su contraseña...',
    'Edit Portal User': 'Editar Usuario del Portal',
    'User Details': 'Detalles del Usuario',
    'Personal Data': 'Datos Personales',
    'View Details': 'Ver Detalles',
    'View Holder Details': 'Ver Detalles del Titular',
    'View Boards': 'Ver Tableros',
    'View Content Store': 'Ver Tienda de Contenidos',
    'Created boards': 'Tableros creados',
    Total: 'Total',
    'Published boards': 'Tableros publicados',
    'No holder linked': 'Ningún titular vinculado',
    'No customer linked': 'Ningún cliente vinculado',
    'User Boards': 'Tableros del Usuario',
    'View boards created by this user': 'Ver tableros creados por este usuario',
    'Customer not found': 'Cliente no encontrado',
    'Loading boards': 'Cargando tableros',
    "This user hasn't created any boards yet":
      'Este usuario aún no ha creado tableros',
    'Create Holder': 'Crear Titular',
    'Edit Holder': 'Editar Titular',
    'Holder created successfully!': '¡Titular creado con éxito!',
    'No user found for this email. Fill in the fields below to create a new holder user.':
      'No se encontró ningún usuario con este correo. Complete los campos a continuación para crear un nuevo usuario titular.',
    'Holder updated successfully!': '¡Titular actualizado con éxito!',
    'Holder deleted successfully!': '¡Titular eliminado con éxito!',
    'Are you sure you want to delete this holder?':
      '¿Está seguro de que desea eliminar este titular?',
    'Are you sure you want to delete holder':
      '¿Está seguro de que desea eliminar el titular',
    'Release all licenses from this holder':
      'Liberar todas las licencias de este titular',
    'Permanently delete the holder': 'Eliminar permanentemente el titular',
    '{{count}} licenses released.': '{{count}} licencias liberadas.',
    'Failed to delete holder!': '¡Error al eliminar titular!',
    'User is required': 'Usuario es obligatorio',
    'Country is required': 'País es obligatorio',
    'Zipcode is required': 'Código postal es obligatorio',
    'Phone number is required': 'Número de teléfono es obligatorio',
    'enter zipcode...': 'ingrese código postal...',
    'enter address...': 'ingrese dirección...',
    'enter city...': 'ingrese ciudad...',
    'enter state...': 'ingrese estado...',
    'enter phone number...': 'ingrese número de teléfono...',
    'enter professional record...': 'ingrese registro profesional...',
    'Professional Record': 'Registro Profesional',
    'Holder Details': 'Detalles del Titular',
    'Professional Information': 'Información Profesional',
    'No licenses linked': 'No hay licencias vinculadas',
    'Livox User Details': 'Detalles del Usuario Livox',
    'Personal Information': 'Información Personal',
    'Health Information': 'Información de Salud',
    'Contact Information': 'Información de Contacto',
    'Responsible Information': 'Información del Responsable',
    'Responsible 1 Name': 'Nombre del Responsable 1',
    'Responsible 1 Email': 'Correo del Responsable 1',
    'Responsible 1 Phone': 'Teléfono del Responsable 1',
    'Responsible 2 Name': 'Nombre del Responsable 2',
    'Responsible 2 Email': 'Correo del Responsable 2',
    'Responsible 2 Phone': 'Teléfono del Responsable 2',
    'Autonomy Level': 'Nivel de Autonomía',
    'Current Communication': 'Comunicación Actual',
    'Visual Impairment': 'Discapacidad Visual',
    'Fine Motor Skills': 'Habilidades Motoras Finas',
    'Repetitive Movements': 'Movimientos Repetitivos',
    'Hearing Impairment': 'Discapacidad Auditiva',
    'No data available': 'No hay datos disponibles',
    'Edit Livox User': 'Editar Usuario Livox',
    Unauthorized: 'No autorizado',
    'Board settings': 'Configuración del tablero',
    'Board name and cover': 'Nombre y portada del tablero',
    'Board name': 'Nombre del tablero',
    'Board cover image': 'Imagen de portada del tablero',
    'Board cover': 'Portada del tablero',
    'Click the image to change': 'Haz clic en la imagen para cambiar',
    'Error uploading image': 'Error al subir la imagen',
    'Error saving title': 'Error al guardar el nombre',
    'Move cards': 'Mover tarjetas',
    'Select cards': 'Seleccionar tarjetas',
    Redo: 'Rehacer',
    Help: 'Ayuda',
    Layout: 'Diseño',
    'Board background color': 'Color de fondo del tablero',
    'Card settings': 'Configuración de tarjetas',
    'Fixed bar settings': 'Configuración de la barra fija',
    'Lock board horizontal': 'Bloquear tablero en horizontal',
    'Auto navigation cards': 'Tarjetas de navegación automática',
    back: 'atrás',
    Columns: 'Columnas',
    'Select background color': 'Seleccionar color de fondo',
    'General card settings': 'Configuración general de tarjetas',
    'Show text only': 'Mostrar solo texto',
    'Text position': 'Posición del texto',
    Bottom: 'Inferior',
    Top: 'Superior',
    'Show cards with levels as folders':
      'Mostrar tarjetas con niveles como carpetas',
    'High contrast cards': 'Tarjetas de alto contraste',
    'Black and white cards': 'Tarjetas en blanco y negro',
    IntelliBar: 'IntelliBar',
    'Enable IntelliBar': 'Activar IntelliBar',
    'IntelliBar description':
      'Cuando está activado, Livox mostrará una barra en la parte superior de la pantalla donde el usuario puede crear frases. Esta función requiere descargar el tablero de tarjetas de conversación IntelliBar si aún no lo ha hecho.',
    'IntelliBar screen size': 'Tamaño de IntelliBar en pantalla',
    'Speak card when adding to IntelliBar':
      'Leer la tarjeta al añadirla a IntelliBar',
    Disabled: 'Desactivado',
    Enabled: 'Habilitado',
    'Partially enabled': 'Parcialmente habilitado',
    intelibar_speak_disabled_desc:
      'Livox solo hablará al tocar el botón de hablar de la IntelliBar.',
    intelibar_speak_partial_desc:
      'Livox hablará la tarjeta tocada que se inserta en la IntelliBar.',
    intelibar_speak_full_desc: 'Livox hablará todas las tarjetas tocadas.',
    'Speak card before adding': 'Leer la tarjeta antes de añadir',
    'Speak card after adding': 'Leer la tarjeta después de añadir',
    'Show only card text in IntelliBar':
      'Mostrar solo el texto de la tarjeta en IntelliBar',
    'Enable fixed bar': 'Activar barra fija',
    'Fixed bar scroll up': 'Desplazar barra fija hacia arriba',
    'Fixed bar scroll down': 'Desplazar barra fija hacia abajo',
    'Fixed bar scroll left': 'Desplazar barra fija hacia la izquierda',
    'Fixed bar scroll right': 'Desplazar barra fija hacia la derecha',
    'Fixed bar limit reached': 'Se alcanzó el límite de la barra fija',
    Position: 'Posición',
    Side: 'Lateral',
    'Visible cards count': 'Cantidad de tarjetas visibles',
    'Show as folder': 'Mostrar como carpeta',
    'Select card bar color': 'Seleccionar color de la barra de tarjetas',
    'Create a Card': 'Crear una tarjeta',
    Image: 'Imagen',
    'Text/Spoken text': 'Texto / texto hablado',
    'Color Background': 'Color de fondo',
    'Add media': 'Añadir multimedia',
    'Image Bank': 'Banco de imágenes',
    'Artificial Intelligence': 'Inteligencia artificial',
    'Search image': 'Buscar imagen',
    'Starts with': 'Empieza con',
    'Card title': 'Título de la tarjeta',
    'Spoken Text': 'Texto hablado',
    'Letters; Numbers': 'Letras; Números',
    'Text/Spoken Text': 'Texto / Texto hablado',
    card_title_description: 'Este texto se mostrará en la tarjeta.',
    'Spoken text': 'Texto hablado',
    spoken_text_description:
      'Este texto se leerá. Puede escribir textos largos si lo desea.',
    'Text font': 'Fuente del texto',
    'Text color': 'Color del texto',
    'Background Color': 'Color de fondo',
    'Background color card': 'Color de fondo de la tarjeta',
    'Card border color': 'Color del borde de la tarjeta',
    'Attach a media': 'Adjuntar multimedia',
    'No media': 'Sin multimedia',
    'Record an audio': 'Grabar un audio',
    'Pick an audio': 'Elegir un audio',
    'Pick a video': 'Elegir un vídeo',
    'Cards Properties': 'Propiedades de las tarjetas',
    'Show just text': 'Mostrar solo texto',
    show_just_text_desc:
      'Si está activado, Livox ya no mostrará tarjetas con imagen',
    'Large size images': 'Imágenes de gran tamaño',
    large_images_desc: 'Si está activado, las tarjetas aparecerán más grandes',
    'Keep the card unchanged': 'Mantener la tarjeta sin cambios',
    keep_unchanged_desc:
      'Esta tarjeta no se modificará en tableros con valores predeterminados',
    'Display card in folder format': 'Mostrar tarjeta en formato carpeta',
    'Card Title': 'Título de la tarjeta',
    'Upload Card': 'Subir tarjeta',
    'Board layout': 'Diseño del tablero',
    'Maintain relative positioning': 'Mantener posicionamiento relativo',
    help_move: 'Active para arrastrar y reordenar tarjetas en el tablero.',
    help_select: 'Active para seleccionar varias tarjetas a la vez.',
    help_yesno: 'Active para añadir botones Sí/No en las tarjetas.',
    help_undo_redo: 'Deshacer o rehacer cambios en la configuración.',
    help_play_mode:
      'Abre el tablero en pantalla completa para usarlo de verdad: navega por las tarjetas y carpetas, forma frases y escúchalas.',
    help_export_pdf:
      'Exporta el tablero actual como un archivo PDF para imprimir o compartir.',
    help_ia:
      'Use inteligencia artificial para sugerir tarjetas automáticamente.',
    'Card actions': 'Acciones de la tarjeta',
    Interests: 'Intereses',
    'Android ID': 'Android ID',
    'Advanced Filters': 'Filtros Avanzados',
    'Apply Filters': 'Aplicar Filtros',
    'Clear All': 'Limpiar Todo',
    Order: 'Ordenar',
    Ascending: 'Ascendente',
    Descending: 'Descendente',
    From: 'Desde',
    To: 'Hasta',
    All: 'Todos',
    Information: 'Información',
    Location: 'Ubicación',
    Keys: 'Claves',
    'Date of Birth': 'Fecha de Nacimiento',
    'Activated Licenses': 'Licencias Activadas',
    'Inactivated Licenses': 'Licencias Inactivadas',
    Options: 'Opciones',
    Hide: 'Ocultar',
    Show: 'Mostrar',
    'Enter sublevel': 'Entrar al subnivel',
    'Create folder': 'Crear carpeta',
    'Edit Card': 'Editar tarjeta',
    'Add state': 'Añadir estado',
    'Cannot access cards with more than one state':
      'No se puede acceder a tarjetas con más de un estado.',
    'Cards with sublevels cannot have multiple states':
      'Las tarjetas con subniveles no pueden tener varios estados.',
    Untitled: 'Sin título',
    'No states yet. Add one below.': 'Aún no hay estados. Añade uno abajo.',
    'Generate image': 'Generar imagen',
    'Enter image prompt...': 'Escriba un prompt de imagen...',
    'Image style': 'Estilo de imagen',
    'Download image': 'Descargar imagen',
    Contains: 'Contiene',
    'Type to search symbols': 'Escribe para buscar símbolos',
    'Save failed': 'Error al guardar',
    'Choose file from computer': 'Elegir archivo del ordenador',
    Upload: 'Subir',
    'Upload failed': 'Error al subir',
    'Select from image bank': 'Selecciona del banco de imágenes',
    'Generate with AI': 'Genera con IA',
    Generated: 'Generada',
    'Upload an image from your device': 'Sube una imagen desde tu dispositivo',
    'Choose a symbol from the image bank':
      'Elige un símbolo del banco de imágenes',
    Selected: 'Seleccionado',
    'Unsaved image selected': 'Imagen pendiente de guardar',
    'Upload image from computer': 'Subir imagen del ordenador',
    'Select an image before saving the card.':
      'Seleccione una imagen antes de guardar la tarjeta.',
    'Book Settings': 'Configuración del libro',
    'Text size': 'Tamaño del texto',
    'Highlight spoken text': 'Resaltar texto hablado',
    Exit: 'Salir',
    'Start over': 'Empezar desde el principio',
    'To enable Book Mode, add cards to the board':
      'Para activar el Modo Libro, añade tarjetas al tablero',
    'Deactivate Book Mode to create sublevels':
      'Desactiva el Modo Libro para crear subniveles',
    'Continue from page {{page}}': 'Continuar desde la página {{page}}',
    'Open at page {{page}}': 'Abrir en la página {{page}}',
    'To enable Book Mode, add child cards':
      'Para activar el Modo Libro, añade tarjetas hijas',
    'This book has no pages': 'Este libro no tiene páginas',
  },
}
